import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

export const dt = (s) => (s ? new Date(s).toLocaleString("tr-TR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—");
export const size = (b) => (b > 1048576 ? `${(b / 1048576).toFixed(1)} MB` : `${Math.max(1, Math.round((b || 0) / 1024))} KB`);
export const ORIGIN = { MANUAL: "Elle", AUTO: "Gece otomatik", UPLOAD: "Yüklenen dosya", PRE_RESTORE: "Geri yükleme öncesi", OFFICE_SELF: "Ofis yedeği" };
export const STATUS = { READY: "Hazır", DOWNLOADED: "İndirildi, silindi", EXPIRED: "Süresi doldu, silindi", UPLOADING: "Yükleniyor" };

export async function showError(e) {
  let detail = e.response?.data?.detail;
  if (e.response?.data instanceof Blob) {
    try { detail = JSON.parse(await e.response.data.text()).detail; } catch { detail = null; }
  }
  toast.error(formatApiError(detail));
}

export function saveBlob(data, filename) {
  const url = URL.createObjectURL(new Blob([data], { type: "application/octet-stream" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}

export async function uploadBackup(file, onProgress) {
  const { data } = await api.post("/admin/backups/uploads", { filename: file.name, size: file.size });
  const n = Math.ceil(file.size / data.chunk_size);
  for (let i = 0; i < n; i++) {
    const chunk = file.slice(i * data.chunk_size, (i + 1) * data.chunk_size);
    await api.put(`/admin/backups/uploads/${data.upload_id}/${i}`, chunk, { headers: { "Content-Type": "application/octet-stream" } });
    onProgress(Math.round(((i + 1) / n) * 100));
  }
  return (await api.post(`/admin/backups/uploads/${data.upload_id}/complete`)).data;
}
